var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark__bar"},[_c('div',{staticClass:"bar__content wrapper"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('a',{attrs:{"href":'mailto:' + _vm.email}},[_vm._v(_vm._s(_vm.email))])])])}
var staticRenderFns = []

export { render, staticRenderFns }